import { render } from "./ManageShioriModal.vue?vue&type=template&id=02868fec&scoped=true"
import script from "./ManageShioriModal.vue?vue&type=script&lang=js"
export * from "./ManageShioriModal.vue?vue&type=script&lang=js"

import "./ManageShioriModal.vue?vue&type=style&index=0&id=02868fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02868fec"]])

export default __exports__